export const countLabel = (count: number, label: string, plural?: string) => {
  if (count === 1) {
    return `1 ${label}`;
  }
  return `${count} ${plural || label + "s"}`;
};

/**
 * Convert a snake-case string to camel-case.
 */
export const toCamelCase = (string: string): string => {
  if (!string) {
    return string;
  }
  // TODO some underscore cases (see tests) dont work right
  return string.replace(/((_|\s)(?!\d)\w)/g, (m) => m[1].toUpperCase());
};
